__turbopack_context__.v({
  "givebutton": "GiveButton-module-scss-module__QOmp8G__givebutton",
  "givebuttoninverted": "GiveButton-module-scss-module__QOmp8G__givebuttoninverted",
});
